import { render, staticRenderFns } from "./CanvasArrowsNextBackSlide.vue?vue&type=template&id=46715ca7&scoped=true&"
import script from "./CanvasArrowsNextBackSlide.vue?vue&type=script&lang=js&"
export * from "./CanvasArrowsNextBackSlide.vue?vue&type=script&lang=js&"
import style0 from "./CanvasArrowsNextBackSlide.vue?vue&type=style&index=0&id=46715ca7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46715ca7",
  null
  
)

export default component.exports